module.exports = __webpack_public_path__ + "static/hero-bg-c17c1aaf29925be933229c8eb7a1fd54.gif";